import { render } from "./AppearanceCheck.vue?vue&type=template&id=e2af08fa&scoped=true&ts=true"
import script from "./AppearanceCheck.vue?vue&type=script&lang=ts"
export * from "./AppearanceCheck.vue?vue&type=script&lang=ts"

import "./AppearanceCheck.vue?vue&type=style&index=0&id=e2af08fa&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2af08fa"]])

export default __exports__